import { RecoverySendPasswordAction } from "./recovery.send_password.types";

export const recoverySendPasswordRequestAction = (params: { phone: string; code: string; medic_user_id: number }): RecoverySendPasswordAction => ({ type: 'RECOVERY_SEND_PASSWORD_REQUEST', params })
export const recoverySendPasswordSuccessAction = (): RecoverySendPasswordAction => ({ type: 'RECOVERY_SEND_PASSWORD_SUCCESS' })
export const recoverySendPasswordFailureAction = (error?: any): RecoverySendPasswordAction => ({ type: 'RECOVERY_SEND_PASSWORD_FAILURE', params: error })
